import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../hooks'
import { Spinner } from '../components/spinner'
import { Status } from '../components/status'
import { useUrlAuth } from '../utils/useUrlAuth'

// TODO request new link on link expiry

export const ProtectedRoutes = () => {
  const authState = useAppSelector((state) => state.auth)
  const { isLoading: isAuthLoading, error: authError } = authState
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { urlAuth } = useUrlAuth()

  const uid = localStorage.getItem('uid')
  let isUrlAuthValid = false
  let clientAuthError = ''
  const redirectPath = `/log-in?to=${pathname}`

  if (
    urlAuth.get('token_type') === 'bearer' &&
    urlAuth.has('access_token') &&
    urlAuth.has('refresh_token')
  ) {
    isUrlAuthValid = true
  }

  if (urlAuth.get('error')) {
    if (urlAuth.get('error_code') === 'otp_expired') {
      clientAuthError = 'Link expired'
    } else {
      clientAuthError = urlAuth.get('error_description')
      clientAuthError = clientAuthError.replaceAll('+', ' ')
    }
  }

  return clientAuthError ? (
    <div className='main_content experience_content'>
      <div>
        <Status error={clientAuthError} />
        <span className='span-a' onClick={() => navigate('/', { viewTransition: true })}>
          Back to home page
        </span>
      </div>
    </div>
  ) : authError ? (
    <Navigate to={redirectPath} />
  ) : uid || isUrlAuthValid ? (
    <>{isAuthLoading ? <Spinner size='center' /> : <Outlet />}</>
  ) : (
    <Navigate to={redirectPath} />
  )
}
